import { Base } from "../Base";
export class Class extends Base {
    type;
    name;
    class = "instance";
    constructor(type, name) {
        super();
        this.type = type;
        this.name = name;
    }
    is(value) {
        return value instanceof this.type;
    }
    static create(constructor, name) {
        return new Class(constructor, name);
    }
}
//# sourceMappingURL=Class.js.map